import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import IntelliProveUnsupportedBrowserError from '~errors/unsupported_browser';
import { useSettings } from '~providers/settings';
import { supportsES2020 } from '~utils/device';
import { getAuthContextFromJwt } from '~utils/jwt';
import { getAuthFromSearchParams, getSearchParam } from '~utils/path/search_params';
import { applyComponentTokens, applyTheming, resolveComponentTokens } from '~utils/theming';
import { SectionStore } from './stores/sections';

function AppSetup() {
  const { theming } = useSettings();
  const [authKey] = getAuthFromSearchParams();
  const customerId = useMemo(() => getAuthContextFromJwt(authKey).customerId, [authKey]);

  useEffect(() => {
    // Compatibilty checks
    if (!supportsES2020()) {
      throw new IntelliProveUnsupportedBrowserError();
    }

    // sections
    const metrics = getSearchParam('metrics');
    const biomarkers = getSearchParam('biomarkers');
    const recommendations = getSearchParam('recommendations');
    const todos = getSearchParam('todos');
    const main = getSearchParam('main');
    SectionStore.setState({
      mainEnabled: main !== 'disabled', // Default ON
      metricsEnabled: metrics !== 'disabled', // Default ON
      biomarkersEnabled: biomarkers !== 'disabled', // Default ON
      recommendationsEnabled: recommendations === 'enabled', // Default OFF
      todosEnabled: todos === 'enabled', // Default ON
    });
  }, []);

  useEffect(() => {
    if (theming) applyTheming(theming);
  }, [theming]);

  /**
   * Component tokens are independent of branding: a customer override has to hold
   * even when /v2/branding fails, so this does not wait on `theming`. A
   * `themeToken` override is written as a `var()` reference, so it still picks up
   * whatever `applyTheming` writes afterwards.
   */
  useEffect(() => {
    applyComponentTokens(resolveComponentTokens(customerId));
  }, [customerId]);

  return (
    <>
      <Outlet />
    </>
  );
}

export default AppSetup;
